import axios from "../axios";
import {
    SIGNUP_API, FUTURE_KITCHEN_API,
    GET_SERVING_ZIPCODE_ADMIN_API, LOGIN_API, LOGOUT_API,
    FORGOT_PASSWORD_API, RESET_PASSWORD_API, UPDATE_KITCHEN_OPERATION,
    ADD_DEDICATED_DRIVER,
} from "../ApiUrl";

export const signupAPI = async (payload) => {

    try {
        const response = await axios.post(SIGNUP_API, payload);
        return response;

    } catch (error) {
        console.log("signupAPI catch block", error);
        return { success: false, error };
    }
};


export const loginAPI = async (payload) => {

    try {
        const response = await axios.post(LOGIN_API, payload);
        return response;

    } catch (error) {
        console.log("loginAPI catch block", error);
        return { success: false, error };
    }
};



export const logoutAPI = async () => {

    try {
        const response = await axios.post(LOGOUT_API);
        return response;

    } catch (error) {
        console.log("logoutAPI catch block", error);
        return { success: false, error };
    }
};

export const forgotPasswordAPI = async (payload) => {

    try {
        const response = await axios.post(FORGOT_PASSWORD_API, payload);
        return response;

    } catch (errors) {
        console.log("forgotPasswordAPI catch block", errors);
        return { success: false, errors };
    }
};

export const resetPasswordAPI = async (token, payload) => {

    try {
        const response = await axios.post(RESET_PASSWORD_API, payload, { params: { token } });

        return response;
    } catch (errors) {
        console.log("resetPasswordAPI catch block", errors);
        return { success: false, errors };
    }
};


export const futureKitchenAPI = async (payload) => {

    try {
        const response = await axios.post(FUTURE_KITCHEN_API, payload);
        return response;

    } catch (error) {
        console.log("futureKitchenAPI catch block", error);
        return { success: false, error };
    }
};

export const servingZipcodeAPI = async (zipcode) => {

    try {
        const response = await axios.get(GET_SERVING_ZIPCODE_ADMIN_API, {
            params: {
                zipcode,
            },
        });
        return response;

    } catch (error) {
        console.log("servingZipcodeAPI catch block", error);
        return { success: false, error };
    }
};


export const updateKitchenOperationAPI = async (payload) => {
    try {
        const response = await axios.put(UPDATE_KITCHEN_OPERATION, payload);
        return response;
    } catch (error) {
        await console.log("catch error in updateKitchenOperationAPI", error);
        return error;
    }
};

export const addDedicatedDriverAPI = async (payload) => {
    try {
        const response = await axios.post(ADD_DEDICATED_DRIVER, payload);
        return response;
    } catch (error) {
        console.log("catch error in addDedicatedDriverAPI", error);
        return error;
    }
};

